function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { LocaleCode } from '@tablecheck/locales';
import { toRomaji, isKana, toHiragana, isJapanese as _isJapanese } from 'wanakana';
import { Romanizer } from '../Romanizer.js';
/* eslint-disable eslint-comments/disable-enable-pair, class-methods-use-this */

var Japanese = /*#__PURE__*/function (_Romanizer) {
  _inherits(Japanese, _Romanizer);

  var _super = _createSuper(Japanese);

  function Japanese() {
    _classCallCheck(this, Japanese);

    return _super.apply(this, arguments);
  }

  _createClass(Japanese, [{
    key: "isNative",
    value: function isNative(char) {
      return this.isJapanese(char);
    }
  }, {
    key: "isMatch",
    value: function isMatch(locale) {
      return locale === LocaleCode.Japanese;
    }
  }, {
    key: "transliterateName",
    value: function transliterateName(char) {
      return toRomaji(char);
    }
  }, {
    key: "formatName",
    value: function formatName(name) {
      if (!name) return '';
      return (isKana(name) ? toHiragana(name) : name).toLocaleLowerCase();
    }
  }, {
    key: "normalizeForQuery",
    value: function normalizeForQuery(str) {
      return this.normalizeRomaji(str).toLocaleLowerCase();
    }
  }, {
    key: "normalizeRomaji",
    value: function normalizeRomaji(str) {
      return this.normalizeHanZen(toRomaji(str) || '');
    }
  }, {
    key: "isJapanese",
    value: function isJapanese(name) {
      if (!name) return false;
      return name.split('').some(function (char) {
        return _isJapanese(char);
      });
    }
  }, {
    key: "normalizeHanZen",
    value: function normalizeHanZen(str) {
      var toNormalize = str; // replaces full width characters with half width characters

      toNormalize = toNormalize.replace(/[Ａ-Ｚａ-ｚ０-９｛｜｝～！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
      });
      toNormalize = toNormalize.replace(/\u3000/g, ' ').replace(/[−ー―－‐]/g, '-').replace(/[・。．]/g, '.').replace(/[∕⁄／]/g, '/').replace(/￥/g, '¥');
      return toNormalize;
    }
  }]);

  return Japanese;
}(Romanizer);

export { Japanese };
